var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleUpArrow = function SvgDoubleUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 18.354 6.346 17.3 12 11.646l5.654 5.654-1.054 1.054-4.6-4.585zm0-6L6.346 11.3 12 5.646l5.654 5.654-1.054 1.054L12 7.769z"
  })));
};
export default SvgDoubleUpArrow;